import emailjs from "emailjs-com";
import React, { useRef, useState } from "react";

export default function ContactMe() {
  const form = useRef();
  const [isSent, setIsSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    const name =
      form.current["first-name"].value + " " + form.current["last-name"].value;
    const email = form.current["email"].value;
    const phoneNumber = form.current["phone-number"].value;
    const message = form.current["message"].value;

    const mergedMessage = `Name: ${name}\nEmail: ${email}\nPhone Number: ${phoneNumber}\n\n${message}`;

    const emailParams = {
      user_name: name,
      user_email: email,
      message: mergedMessage,
    };

    emailjs
      .send(
        "service_u01hwjl",
        "template_5zkjreb",
        emailParams,
        "iHSIu-yIamEqySkbO"
      )
      .then((result) => {
        console.log(result.text);
        setIsSent(true);
        setTimeout(() => setIsSent(false), 3000); // Hide message after 3 seconds
      })
      .catch((error) => {
        console.log(error.text);
        setIsSent(false);
      });
  };

  return (
    <section id="Contact" className="contact--section">
      <div>
        <p className="sub--title">Get In Touch</p>
        <h2>Contact Me</h2>
        <p className="text-lg">
          My Email - shanakaprince@gmail.com <br /> <br />
          Phone Numbers - +94 76 9125141 , +94 71 1857327
          <br /> <br /> else, Plz fill below form and submit
        </p>
      </div>
      <form
        ref={form}
        onSubmit={sendEmail}
        className="contact--form--container"
      >
        <div className="container">
          <label htmlFor="first-name" className="contact--label">
            <span className="text-md">First Name</span>
            <input
              type="text"
              className="contact--input text-md"
              name="first-name"
              id="first-name"
              required
            />
          </label>
          <label htmlFor="last-name" className="contact--label">
            <span className="text-md">Last Name</span>
            <input
              type="text"
              className="contact--input text-md"
              name="last-name"
              id="last-name"
              required
            />
          </label>
          <label htmlFor="email" className="contact--label">
            <span className="text-md">Email</span>
            <input
              type="email"
              className="contact--input text-md"
              name="email"
              id="email"
              required
            />
          </label>
          <label htmlFor="phone-number" className="contact--label">
            <span className="text-md">Phone Number</span>
            <input
              type="number"
              className="contact--input text-md"
              name="phone-number"
              id="phone-number"
              required
            />
          </label>
        </div>

        <label htmlFor="message" className="contact--label">
          <span className="text-md">Message</span>
          <textarea
            className="contact--input text-md"
            id="message"
            name="message"
            rows="8"
            placeholder="Type your message..."
            required
          />
        </label>

        <div>
          <button type="submit" className="btn btn-primary contact--form--btn">
            Submit
          </button>
        </div>
      </form>

      {isSent && (
        <div className="alert show">
          Message sent successfully!
          <span className="close" onClick={() => setIsSent(false)}>
            &times;
          </span>
        </div>
      )}
    </section>
  );
}
